import React from 'react';
import PropTypes from 'prop-types';

import Deadline from './Deadline';
import Header from './Header';
import LogisticDetails from './LogisticDetails';
import MediaAndDistribution from './MediaAndDistribution';
import OutsidePitchingNotice from './OutsidePitchingNotice';
import RequestDetails from './RequestDetails';
import RequestType from './RequestType';

function NewRequestBody(props) {
  const { showLogisticDetails } = props;
  const {
    saveDraft,
    toggleParam,
    updateParam,
    useUpdateParamWithEvent,
    markFieldTouched,
    ...otherProps
  } = props;

  return (
    <div className="new-request-body">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Header {...otherProps} />
      {otherProps.internalUser && (
        <div className="alert alert-staff mx-auto mb-3" style={{ maxWidth: '1200px' }}>
          Heads up! You&apos;re using the new V2 source request form.
        </div>
      )}
      {otherProps.internalUser && !otherProps.targetReporterProfileId && (
        <div className="alert alert-danger mx-auto mb-3" style={{ maxWidth: '1200px' }}>
          <i className="fa fa-exclamation-triangle me-2" />
          <strong>You are creating this request on your own account.</strong>
          {' '}
          To create on behalf of a reporter, open the form from their profile page.
        </div>
      )}
      {otherProps.targetReporterProfileId && (
        <div className="alert alert-info border-primary mx-auto mb-3" style={{ maxWidth: '1200px' }}>
          <i className="fa fa-info-circle me-2" />
          <strong>
            {otherProps.targetUserName
              ? `Creating on behalf of ${otherProps.targetUserName}.`
              : 'Creating on behalf of another user.'}
          </strong>
          {' '}
          This request will be created for them, not you.
        </div>
      )}
      <div className="row mx-auto" style={{ maxWidth: '1200px' }}>
        <div className="col">
          <div id="request-type">
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <RequestType {...otherProps} updateParam={updateParam} useUpdateParamWithEvent={useUpdateParamWithEvent} />
          </div>
          <div>
            <div id="request-details">
              <RequestDetails
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...otherProps}
                updateParam={updateParam}
                useUpdateParamWithEvent={useUpdateParamWithEvent}
                markFieldTouched={markFieldTouched}
              />
            </div>
            <div id="media-distribution">
              <MediaAndDistribution
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...otherProps}
                toggleParam={toggleParam}
                updateParam={updateParam}
                useUpdateParamWithEvent={useUpdateParamWithEvent}
              />
            </div>
            <div id="logistic-details">
              {showLogisticDetails && (
                <LogisticDetails
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...otherProps}
                  toggleParam={toggleParam}
                  useUpdateParamWithEvent={useUpdateParamWithEvent}
                  markFieldTouched={markFieldTouched}
                />
              )}
            </div>
            <div id="deadline">
              <Deadline
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...otherProps}
                saveDraft={saveDraft}
                toggleParam={toggleParam}
                updateParam={updateParam}
                useUpdateParamWithEvent={useUpdateParamWithEvent}
                markFieldTouched={markFieldTouched}
              />
            </div>
            <OutsidePitchingNotice />
          </div>
        </div>
      </div>
    </div>
  );
}

NewRequestBody.propTypes = {
  abandonChangesAndExit: PropTypes.func,
  postRequest: PropTypes.func.isRequired,
  saveDraft: PropTypes.func.isRequired,
  saveAndExit: PropTypes.func,
  toggleParam: PropTypes.func.isRequired,
  updateParam: PropTypes.func.isRequired,
  useUpdateParamWithEvent: PropTypes.func.isRequired,
  markFieldTouched: PropTypes.func.isRequired,
  currentUiState: PropTypes.string.isRequired,
  formMode: PropTypes.string,
  showLogisticDetails: PropTypes.bool,
  savingState: PropTypes.string.isRequired,
  backlinkOpportunity: PropTypes.bool,
  customDeadlineDateTime: PropTypes.string,
  customScheduleDateTime: PropTypes.string,
  deadline: PropTypes.string,
  details: PropTypes.string,
  detailsDisplay: PropTypes.string,
  distribution: PropTypes.string,
  distributeExternally: PropTypes.bool,
  equipmentNotes: PropTypes.string,
  equipmentNotesDisplay: PropTypes.string,
  eventType: PropTypes.string,
  paid: PropTypes.bool,
  logisticsInPerson: PropTypes.bool,
  logisticsLive: PropTypes.bool,
  logisticsPreRecorded: PropTypes.bool,
  logisticsRemote: PropTypes.bool,
  logisticsUrl: PropTypes.string,
  logisticsVideo: PropTypes.bool,
  lookingFor: PropTypes.string,
  manOnTheStreet: PropTypes.bool,
  notification: PropTypes.string,
  personType: PropTypes.string,
  title: PropTypes.string,
  titleDisplay: PropTypes.string,
  schedule: PropTypes.string,
  speakerRequest: PropTypes.bool,
  mediaOutletId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  timeNow: PropTypes.number.isRequired,
  internalUser: PropTypes.bool,
  targetReporterProfileId: PropTypes.number,
  targetUserName: PropTypes.string,
};

NewRequestBody.defaultProps = {
  abandonChangesAndExit: null,
  saveAndExit: null,
  formMode: 'create',
  showLogisticDetails: true,
  backlinkOpportunity: false,
  customDeadlineDateTime: '',
  customScheduleDateTime: '',
  deadline: '7days',
  details: '',
  detailsDisplay: '',
  distribution: null,
  distributeExternally: true,
  equipmentNotes: '',
  equipmentNotesDisplay: '',
  eventType: null,
  paid: false,
  logisticsInPerson: false,
  logisticsLive: false,
  logisticsPreRecorded: false,
  logisticsRemote: false,
  logisticsUrl: '',
  logisticsVideo: false,
  lookingFor: 'person',
  manOnTheStreet: false,
  notification: null,
  personType: 'expert',
  title: '',
  titleDisplay: '',
  schedule: 'now',
  speakerRequest: false,
  mediaOutletId: '',
  internalUser: false,
  targetReporterProfileId: null,
  targetUserName: null,
};

export default NewRequestBody;
